<template>
    <ul class="row">
        <li><router-link :to="`/data/ai/prompts/${prompt.id}`">{{ prompt.name||prompt.id }}</router-link> <template v-if="prompt.act==0">(отключено)</template></li>
    </ul>
</template>

<script>
    export default {
        data(){
            return {
            }
        },
        props:{
            prompt: {type: Object}
        },
        methods:{
            onEdit(){
                this.$router.push({path:this.prompt.id});
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>